import { createButton, createLabeledInput, createModal } from '../components.js';
import { isComposing } from '../../shared/typing-target.js';

import { PAGE_NAME_MAX_LEN } from '../../pages/page-name-utils.js';

// BC-9: one limit. This was a second `= 60` beside page-name-utils' own, and
// the day one moved the phone dialog would have accepted names the store trims.
export const PAGE_RENAME_MAX_LEN = PAGE_NAME_MAX_LEN;

/** A phone rename is one result; dismissal, empty and unchanged names return null. */
export function showRenamePageDialog({ name = '', signal } = {}) {
  if (signal?.aborted) return Promise.resolve(null);
  return new Promise((resolve) => {
    let settled = false;
    let field;
    const finish = (value) => {
      if (settled) return;
      settled = true;
      signal?.removeEventListener('abort', cancel);
      resolve(value);
    };
    const modal = createModal({
      title: 'Rename page',
      size: 'sm',
      initialFocus: () => field.input,
      onClose: () => finish(null)
    });
    const cancel = () => {
      finish(null);
      modal.close();
    };
    signal?.addEventListener('abort', cancel, { once: true });
    field = createLabeledInput({ label: 'Page name', value: name });
    field.input.maxLength = PAGE_RENAME_MAX_LEN;
    const submit = () => {
      const next = field.input.value.trim().slice(0, PAGE_RENAME_MAX_LEN);
      finish(next && next !== name ? next : null);
      modal.close();
    };
    field.input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || isComposing(event)) return;
      event.preventDefault();
      event.stopPropagation();
      submit();
    });
    modal.body.append(field.wrap);
    modal.footer.append(
      createButton({ variant: 'secondary', label: 'Cancel', onClick: cancel }),
      createButton({ variant: 'primary', label: 'Rename', onClick: submit })
    );
  });
}
